import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect, Switch } from "react-router-dom";
// import { setParents } from "../store";

const ParentRoute = ({ component: Component, parent, to, ...rest }) => {
  document.getElementsByTagName("html")[0].className = "console-pages";
  document.getElementsByTagName("html")[0].style.fontSize = "initial";
  document.getElementsByTagName("html")[0].style.lineHeight = "initial";
  // setParents();
  return (
    <Switch>
      <Route
        {...rest}
        render={props =>
          parent ? (
            <Component {...props} {...rest} />
          ) : (
            <Redirect
              to={{
                pathname: to,
                state: { redirect: props.location.pathname, parent }
              }}
            />
          )
        }
      />
    </Switch>
  );
};

ParentRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  parent: PropTypes.bool.isRequired,
  location: PropTypes.object,
  to: PropTypes.string
};

ParentRoute.defaultProps = {
  to: "/"
};

export default ParentRoute;
